import { render, staticRenderFns } from "./providers-settings.vue?vue&type=template&id=cc07361a"
import script from "./providers-settings.vue?vue&type=script&lang=js"
export * from "./providers-settings.vue?vue&type=script&lang=js"
import style0 from "./providers-settings.vue?vue&type=style&index=0&id=cc07361a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports